export default __webpack_public_path__ + "static/media/sappito_tech_blanco_920.b017d4b7.png";